import { Divider } from "@wix/design-system";
import React from "react";
import classes from "./list-item-divider-scss.js";
const ListItemDivider = () => {
  return /* @__PURE__ */ React.createElement("div", { className: classes.divider }, /* @__PURE__ */ React.createElement(Divider, null));
};
export {
  ListItemDivider
};
//# sourceMappingURL=list-item-divider.js.map
